const getNoOfSubscribedVehicles = (type, vehiclesWithSubscription) => vehiclesWithSubscription ?
    vehiclesWithSubscription.filter(vehicle => vehicle.currentLevel.startsWith(type)).length :
    0;

export default getNoOfSubscribedVehicles;
